import React from 'react'
import { Component } from 'reflux'
import { Box, CircularProgress, Typography } from '@material-ui/core'
import { PurchaseOrderStore, PurchaseOrderStoreActions } from '../../stores/purchaseOrderStore'

export default class PurchaseOrderPrepaymentSummary extends Component {
  constructor(props) {
    super(props)
    this.stores = [PurchaseOrderStore]
    this.storeKeys = ['prepaymentTotals', 'prepaymentSummaryLoading']
  }

  componentDidMount() {
    PurchaseOrderStoreActions.getPrepaymentSummary()
  }

  render() {
    const { prepaymentTotals, prepaymentSummaryLoading } = this.state
    const rows = prepaymentTotals || []
    return (
      <Box mb={1.5} display='flex' alignItems='center' gap={1}>
        <Typography variant='body2' color='textSecondary'>
          Total forudbetaling:
        </Typography>
        {prepaymentSummaryLoading ? (
          <CircularProgress size={14} aria-label='Henter forudbetalinger' />
        ) : rows.length ? (
          rows.map(row => (
            <Typography key={row.currency} variant='body2' style={{ marginRight: 8 }}>
              {row.total.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {row.currency} ({row.count})
            </Typography>
          ))
        ) : (
          <Typography variant='body2'>0</Typography>
        )}
      </Box>
    )
  }
}
